// Per-month amount overrides.
//
// A node carries an optional map of month -> amount in its meta. Resolving an
// override means swapping the node's primary figure for that month's value. This
// happens at one choke point: the engine resolves before computing (so a month's
// maths honours the override), and the web resolves before display (so the
// canvas shows the effective figure). The stored default is never mutated.
/** Return the node with its primary amount replaced by the override for `month`,
 * if one exists; otherwise the node unchanged. The field swapped depends on the
 * node type. */
export function withMonthlyOverrides(node, month) {
    switch (node.type) {
        case "income": {
            const value = node.meta.overrides?.[month];
            return value === undefined ? node : { ...node, meta: { ...node.meta, amount: value } };
        }
        case "bill": {
            const value = node.meta.overrides?.[month];
            return value === undefined ? node : { ...node, meta: { ...node.meta, amount: value } };
        }
        case "oneoff": {
            const value = node.meta.overrides?.[month];
            return value === undefined ? node : { ...node, meta: { ...node.meta, amount: value } };
        }
        case "external": {
            const value = node.meta.overrides?.[month];
            return value === undefined ? node : { ...node, meta: { ...node.meta, amount: value } };
        }
        case "card": {
            const value = node.meta.overrides?.[month];
            return value === undefined ? node : { ...node, meta: { ...node.meta, payment: value } };
        }
        case "pot": {
            const value = node.meta.overrides?.[month];
            return value === undefined ? node : { ...node, meta: { ...node.meta, topUp: value } };
        }
        default:
            return node;
    }
}
/** Whether an obligation has been ticked off as paid for the given month. */
export function isPaid(node, month) {
    switch (node.type) {
        case "bill":
        case "card":
        case "oneoff":
        case "pot":
        case "external":
            return node.meta.paid?.[month] === true;
        default:
            return false;
    }
}
//# sourceMappingURL=overrides.js.map